module.exports = __webpack_public_path__ + "img/au.b966d328.svg";